import { KitchenOrder } from "../types";

export const getClientNameForOrder = (order: KitchenOrder): string => {
  if (order?.client?.name) return order?.client?.name;

  if (order?.clientName) return order?.clientName;

  return 'Sem Nome';
};
